import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useAuth } from "./context/auth";

function HomeRoute({ component: Component, ...rest }) {
  const { authTokens } = useAuth();

  return (
    <Route
      {...rest}
      render={props =>
        authTokens ? (
          <Redirect
            to={{ pathname: "/me", state: { referer: props.location } }}
          />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
}

export default HomeRoute;